import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[input-host]',
})
export class BotatoChatInputDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
